<template>
  <div class="content">
    <div class="list">
      <el-row style="border-bottom: 1px solid #DCDCDC;margin-bottom: 18px;padding: 22px 0;">
        <el-col :span="12">
          <span style="color: #3D3D3D">客户主档管理</span>
        </el-col>
        <el-col style="display: flex;align-items:center;justify-content: flex-end" :span="12">
          <el-upload
              :show-file-list="false"
              class="upload-demo"
              :data="{createBy:user.userName}"
              :action="`${$urlHttp}/customerRating/uploadCrListFile`"
              :on-change="handleUpdate"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :on-exceed="handleExceed">
            <div class="select_xin">导入客户信息</div>
          </el-upload>
            <div @click="exportExcelSampleList" class="select_xia">导出客户信息</div>
          <a :href="`${$urlHttp}/statics/excel/客户主档导入模板.xlsx`" style="text-decoration: none">
            <div class="select_xia">下载导入模版</div>
          </a>
          <div v-if="$buttonStatus('客户主档-添加')" @click="addOfEdit(true)" class="select_xin">新增</div>
        </el-col>
      </el-row>
      <el-form ref="searchForm" :rules="searchForm" :model="searchForm">
        <el-row style="border-bottom: 1px solid #DCDCDC;">
          <el-col :span="6">
            <el-form-item prop="customerCode" label="客户代码" label-width="80px">
              <el-input style="width: 80%" v-model="searchForm.customerCode" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="salesEmployee" label="销售雇员" label-width="80px">
              <el-select filterable collapse-tags style="width: 80%" v-model="searchForm.salesEmployee">
                <el-option
                    v-for="(value,key) in salesEmployeeDropDownBoxList"
                    :key="key"
                    :label="value"
                    :value="value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="customerAbbreviation" label="客户简称" label-width="80px">
              <el-input style="width: 80%" v-model="searchForm.customerAbbreviation" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="customerRating" label="客户评级" label-width="80px">
              <el-select filterable style="width: 80%" v-model="searchForm.customerRating">
                <el-option
                    label="全部"
                    value="">
                </el-option>
                <el-option
                    v-for="(value,key) in ratingFunctionList"
                    :key="key"
                    :label="value"
                    :value="value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="industry" label="行业" label-width="100px">
              <el-select filterable collapse-tags style="width: 80%" v-model="searchForm.industry">
                <el-option
                    v-for="(value,key) in deliveryDataIndustryDropboxList"
                    :key="key"
                    :label="value"
                    :value="value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <div style="display: flex">
                <div @click="customers_group()" class="select_sou">搜 索</div>
                <div @click="resetForm('searchForm')" class="select_chong">重 置</div>
              </div>

            </el-form-item>
            <div style="display: flex">
              <el-popconfirm
                  v-if="$buttonStatus('客户主档-删除')"
                  title="确认批量删除吗？"
                  @confirm="delBatch"
              >
                <div slot="reference" v-if="$buttonStatus('客户主档-删除')" class="select_chong">批量删除</div>
              </el-popconfirm>
              <el-popconfirm
                  v-if="$buttonStatus('客户主档-删除')"
                  title="确认删除搜索结果吗？"
                  @confirm="delBatchSearch"
              >
                <div slot="reference" v-if="$buttonStatus('客户主档-删除')" class="select_chong">删除搜索结果</div>
              </el-popconfirm>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="tableDiv">
        <div class="tableDiv_div">
          <el-table

              :data="tableData"
              @selection-change="handleSelectionChange"
              style="width: 100%">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="id"
                type="index"
                label="编号"
            >
            </el-table-column>
            <el-table-column
                prop="customerCode"
                label="客户代码"
            >
            </el-table-column>
            <el-table-column
                prop="customerFullName"
                label="客户全称"
            >
            </el-table-column>
            <el-table-column
                prop="customerAbbreviation"
                label="客户简称"
            >
            </el-table-column>
            <el-table-column
                prop="industry"
                label="行业"
            >
            </el-table-column>
            <el-table-column
                prop="salesEmployee"
                label="销售雇员"
            >
            </el-table-column>
            <el-table-column
                prop="customerRating"
                label="客户评级"
            >
            </el-table-column>
            <el-table-column
                prop="createBy"
                label="创建者"
            >
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
            >
            </el-table-column>
            <el-table-column
                prop="updateBy"
                label="更新者"
            >
            </el-table-column>
            <el-table-column
                prop="updateTime"
                label="更新时间"
            >
            </el-table-column>
            <el-table-column
                label="操作"
                width="200"
            >
              <template slot-scope="scope">
                <el-button
                    v-if="$buttonStatus('客户主档-编辑')"
                    size="mini"
                    type="warning"
                    @click="addOfEdit(false, scope.row)">编辑
                </el-button>
                <el-popover
                    v-if="$buttonStatus('客户主档-删除')"
                    style="margin-left: 10px"
                    placement="top"
                    width="160"
                    v-model="scope.row.tanshan">
                  <p>确定删除该客户主档吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="scope.row.tanshan = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="customers_groupDel(scope.row.id,scope.row.tanshan)">
                      确定
                    </el-button>
                  </div>
                  <el-button
                      slot="reference"
                      size="mini"
                      type="danger">删除
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            background
            style="margin-top: 30px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="20"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="tanStatus?'添加客户主档管理':'修改客户主档管理'" :visible.sync="dialogFormVisible">
      <el-form ref="ruleForm" :rules="rules" :model="ruleForm">
        <el-form-item prop="customerCode" label="客户代码" label-width="100px">
          <el-input style="width: 50%" v-model="ruleForm.customerCode" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="customerFullName" label="客户全称" label-width="100px">
          <el-input style="width: 50%" v-model="ruleForm.customerFullName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="customerAbbreviation" label="客户简称" label-width="100px">
          <el-input style="width: 50%" v-model="ruleForm.customerAbbreviation" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="industry" label="行业" label-width="100px">
          <el-select filterable style="width: 50%" v-model="ruleForm.industry">
            <el-option
                v-for="(value,key) in deliveryDataIndustryDropboxList"
                :key="key"
                :label="value"
                :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="salesEmployee" label="销售雇员" label-width="100px">
          <el-select filterable style="width: 50%" v-model="ruleForm.salesEmployee">
            <el-option
                v-for="(value,key) in salesEmployeeDropDownBoxList"
                :key="key"
                :label="value"
                :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerRating" label="客户评级" label-width="100px">
          <el-select filterable style="width: 50%" v-model="ruleForm.customerRating">
            <el-option
                v-for="(value,key) in ratingFunctionList"
                :key="key"
                :label="value"
                :value="value">
            </el-option>
          </el-select>
        </el-form-item>

        <!--        <el-form-item prop="createBy" label="创建者" label-width="100px">-->
        <!--          <el-input style="width: 50%" v-model="ruleForm.createBy" autocomplete="off"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item style="margin-left:100px;">
          <el-button @click="addSubmit('ruleForm')">确认</el-button>
          <el-button type="primary" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {httpList} from "@/components/request";

//     "id": id,
//     "customerCode": 客户代码,
//     "customerFullName": 客户全称,
//     "customerAbbreviation": 客户简称,
//     "industry": 行业,
//     "salesEmployee": 销售雇员,
//     "customerRating": 客户评级,
//     "createBy": 创建者,
//     "createTime": 创建时间,
//     "updateBy": 更新者,
//     "updateTime": 更新时间

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "CustomerUserList",
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      tanStatus: true,
      user: {},
      ruleForm: {
        id: 0,
        customerCode: "",//客户代码
        customerFullName: "",//客户全称
        industry: "",//行业
        customerAbbreviation: "",//客户简称
        salesEmployee: "",//销售雇员
        customerRating: "",//客户评级
        createBy: "",//创建者
      },
      rules: {
        customerCode: [
          {required: true, message: '请输入客户代码', trigger: 'blur'}
        ],
        customerFullName: [
          {required: true, message: '请输入客户全称', trigger: 'blur'}
        ],
        industry: [
          {required: true, message: '请选择行业', trigger: 'blur'}
        ],
        customerAbbreviation: [
          {required: true, message: '请输入客户简称', trigger: 'blur'}
        ],
        salesEmployee: [
          {required: true, message: '请选择销售雇员', trigger: 'blur'}
        ],
      },
      total: 0,
      currentPage4: 1,
      tableData: [],
      ratingFunctionList: [],
      selectList: [],
      deliveryDataIndustryDropboxList: [],
      salesEmployeeDropDownBoxList: [],
      searchForm: {
        customerCode: "",
        customerAbbreviation: "",
        industry: "",
        salesEmployee: "",
        customerRating: "",
      },
    }
  },
  mounted() {
// “id”: id,
// “customerAbbreviation”: 客户,
// “customerRating”: 客户评级,
// “createBy”: 创建者,
// “createTime”: 创建时间,
// “updateBy”: 更新者,
// “updateTime”: 更新时间
    let user = JSON.parse(sessionStorage.getItem('user'));
    this.user = user;
    this.customers_group();
    this.ratingFunction();
    this.deliveryDataIndustryDropbox();
    this.salesEmployeeDropDownBox();
  },
  methods: {
    delBatchSearch() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios
          .post(this.$urlHttp + `/customerRating/deleteSearchResults`, {
            'pageNo' : this.currentPage4,
            'pageSize' : 20,
            'customerCode' : this.searchForm.customerCode,
            'salesEmployee' : this.searchForm.salesEmployee,
            'industry' : this.searchForm.industry,
            'customerAbbreviation' : this.searchForm.customerAbbreviation,
            'customerRating' : this.searchForm.customerRating,
          })
          .then((response) => {
            loading.close();
            console.log('customerRating/deleteSearchResults', response.data);
            this.$message(response.data.message);
            if (response.data.code === 200) {
              this.customers_group();
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    delBatch() {
      if (this.selectList.length <= 0) {
        this.$message('请选择客户主档');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let id = [];
      this.selectList.map((value) => {
        id.push(value.id)
      })
      this.axios
          .delete(this.$urlHttp + `/customerRating/delBatch?ids=${id.toString()}`)
          .then((response) => {
            loading.close();
            console.log('customerRating/delBatch', response.data);
            this.$message(response.data.message);
            if (response.data.code === 200) {
              this.customers_group();
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    exportExcelSampleList() {
      let queryString = Object.keys(this.searchForm).map(key => key + '=' + this.searchForm[key]).join('&');
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      window.location.href = this.$urlHttp + `/customerRating/exportExcel?${queryString}`
      loading.close();
    },
    salesEmployeeDropDownBox() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios
          .get(this.$urlHttp + `/dropDownBox/personnelDropDownBox`)
          .then((response) => {
            console.log('dropDownBox/industryDropDownBox', response.data);
            loading.close();
            if (response.data.code === 200) {
              this.salesEmployeeDropDownBoxList = response.data.personnelList;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    deliveryDataIndustryDropbox() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios
          .get(this.$urlHttp + `/dropDownBox/industryDropDownBox`)
          .then((response) => {
            console.log('dropDownBox/industryDropDownBox', response.data);
            loading.close();
            if (response.data.code === 200) {
              this.deliveryDataIndustryDropboxList = response.data.industryList;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    handleUpdate(file, fileList) {
      console.log(file, fileList)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (file.response) {
        loading.close();
        this.$message(file.response.msg);
        this.customers_group();
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    addOfEdit(type, data) {
      this.tanStatus = type;
      // this.resetForm('ruleForm');
      if (type) {
        this.ruleForm = {
          id: 0,
          customerCode: "",
          customerFullName: "",
          industry: "",
          customerAbbreviation: "",
          salesEmployee: "",
          createBy: "",
          customerRating: "",
        }
      } else {
        this.ruleForm.id = data.id;
        this.ruleForm.customerCode = data.customerCode;
        this.ruleForm.customerFullName = data.customerFullName;
        this.ruleForm.industry = data.industry;
        this.ruleForm.customerAbbreviation = data.customerAbbreviation;
        this.ruleForm.salesEmployee = data.salesEmployee;
        this.ruleForm.createBy = this.user.userName;
        this.ruleForm.customerRating = data.customerRating;
      }
      this.dialogFormVisible = true;
    },
    ratingFunction() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios
          .get(this.$urlHttp + `/dropDownBox/rateDropDownBox`)
          .then((response) => {
            console.log('dropDownBox/sysDictDataDropDownBox?dictType=rating', response.data);
            loading.close();
            if (response.data.code === 200) {
              this.ratingFunctionList = response.data.rateList;
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_group() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = new FormData();
      data.append('pageNo', this.currentPage4);
      data.append('pageSize', 20);
      data.append('customerCode', this.searchForm.customerCode);
      data.append('salesEmployee', this.searchForm.salesEmployee);
      data.append('industry', this.searchForm.industry);
      data.append('customerAbbreviation', this.searchForm.customerAbbreviation);
      data.append('customerRating', this.searchForm.customerRating);
      this.axios
          .post(this.$urlHttp + `/customerRating/list`, data)
          .then((response) => {
            console.log('customerRating/list', response.data);
            loading.close();
            if (response.data.code === 200) {
              this.tableData = response.data.data;
              this.total = response.data.total;
              this.current_page = response.data.current_page
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    resetPwd(id) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = new FormData();
      data.append('id', id);
      this.axios
          .post(this.$urlHttp + `/sysUser/resetPwd`, data)
          .then((response) => {
            loading.close();
            console.log('sysUser/resetPwd', response.data);
            this.$message(response.data.message);
            if (response.data.code === 200) {
              this.customers_group();
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupAdd() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = new FormData();
      data.append('customerCode', this.ruleForm.customerCode);
      data.append('customerFullName', this.ruleForm.customerFullName);
      data.append('industry', this.ruleForm.industry);
      data.append('customerAbbreviation', this.ruleForm.customerAbbreviation);
      data.append('salesEmployee', this.ruleForm.salesEmployee);
      data.append('customerRating', this.ruleForm.customerRating);
      data.append('createBy', user.userName);
      this.axios
          .post(this.$urlHttp + `/customerRating/add`, data)
          .then((response) => {
            loading.close();
            console.log('customerRating/add', response.data);
            if (response.data.code === 200) {
              this.dialogFormVisible = false;
              this.customers_group();
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupEdit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = new FormData();
      data.append('id', this.ruleForm.id);
      data.append('customerCode', this.ruleForm.customerCode);
      data.append('customerFullName', this.ruleForm.customerFullName);
      data.append('industry', this.ruleForm.industry);
      data.append('customerAbbreviation', this.ruleForm.customerAbbreviation);
      data.append('salesEmployee', this.ruleForm.salesEmployee);
      data.append('customerRating', this.ruleForm.customerRating);
      data.append('createBy', user.userName);
      this.axios
          .post(this.$urlHttp + `/customerRating/edit`, data)
          .then((response) => {
            loading.close();
            console.log('customerRating/edit', response.data);
            if (response.data.code === 200) {
              this.dialogFormVisible = false;
              this.customers_group();
            } else {
              this.$message(response.data.message);
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    customers_groupDel(id) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.axios
          .delete(this.$urlHttp + `/customerRating/del?id=${id}`)
          .then((response) => {
            loading.close();
            console.log('customerRating/del', response.data);
            this.$message(response.data.message);
            if (response.data.code === 200) {
              this.customers_group();
            }
          })
          .catch((error) => console.log(error, "error"));
    },
    addSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.tanStatus) {
            this.customers_groupAdd();
          } else {
            this.customers_groupEdit();
          }
          // this.submit();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      console.log(123, formName)
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage4 = val;
      this.customers_group();
    },
  },
}
</script>

<style scoped>
.content >>> .el-dialog__title {
  color: #FFFFFF;
}

.content >>> .el-dialog__headerbtn .el-dialog__close {
  color: #FFFFFF;
}

.content >>> .el-dialog__header {
  background-color: #4696C8;
}

.ButtonDao {
  background-color: #5BC0DE;
  border: none;
}


.tableDiv >>> .el-table th.el-table__cell {
  color: #0358DD;
}

.tableDiv >>> .el-table .warning-row {
  background: #D6EFFF;
}

.tableDiv >>> .el-table .success-row {
  background: #F3FAFF;
}

.tableDiv_div {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
}

.tableDiv {
  overflow: hidden;
  flex: 1;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.ButtonDao_div {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
}

.listTitle_div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.listTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.list {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #D0D0D0;
  border-radius: 6px;
  background-color: #FFFFFF;
  padding: 15px 10px;
  box-sizing: border-box;
}

.content {
  height: 100%;
  padding: 26px 37px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
</style>
